import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft, Clock } from "lucide-react";
import { fetchArticle } from "../lib/api";
import { Seo } from "../components/Seo";

export default function Article() {
  const { slug } = useParams();
  const [article, setArticle] = useState(null);

  useEffect(() => {
    fetchArticle(slug).then(setArticle).catch(() => {});
  }, [slug]);

  if (!article) {
    return <div className="max-w-[900px] mx-auto px-6 lg:px-10 py-24 text-[#6E7784]">Loading…</div>;
  }

  return (
    <article data-testid="article-page" className="max-w-[820px] mx-auto px-6 lg:px-10 py-12">
      <Seo
        title={article.title}
        description={article.excerpt}
        image={article.thumbnail}
        type="article"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "Article",
          headline: article.title,
          description: article.excerpt,
          image: article.thumbnail,
          author: { "@type": "Person", name: article.author },
          datePublished: article.date,
          publisher: { "@type": "Organization", name: "Peptide Labs N.I." },
        }}
      />
      <Link to="/knowledge" className="inline-flex items-center gap-2 text-sm text-[#6E7784] hover:text-white transition-colors">
        <ArrowLeft size={14} /> Back to Knowledge Base
      </Link>
      <div className="mt-8 label-mono">{article.category}</div>
      <h1 className="mt-4 text-4xl lg:text-5xl leading-tight tracking-tight text-white font-medium">
        {article.title}
      </h1>
      <div className="mt-6 flex items-center gap-3 text-[13px] text-[#6E7784]">
        <span className="text-white/80">{article.author}</span>
        <span>·</span>
        <span>{article.date}</span>
        <span>·</span>
        <span className="inline-flex items-center gap-1.5"><Clock size={13} /> {article.reading_time}</span>
      </div>

      <div className="mt-10 aspect-[16/8] rounded-3xl overflow-hidden border border-[#2A2A2A]">
        <img src={article.thumbnail} alt={article.title} className="w-full h-full object-cover opacity-80" />
      </div>

      <div className="mt-12 space-y-6 text-[16.5px] leading-[1.8] text-[#B7BCC7] font-body">
        {article.content.split("\n\n").map((para, i) => (
          <p key={i} className="whitespace-pre-line">{para}</p>
        ))}
      </div>

      <div className="mt-16 p-6 border border-[#2A2A2A] rounded-2xl bg-[#0e0e0e]">
        <div className="label-mono">Disclaimer</div>
        <p className="mt-2 text-[13px] text-[#6E7784] leading-relaxed">
          All content is provided for research and educational purposes only.
          Peptide compounds sold by Peptide Labs N.I. are intended solely for in-vitro
          laboratory research and are not for human or animal consumption.
        </p>
      </div>
    </article>
  );
}
